import React from 'react'
import useResponsive from 'utils/useResponsive'

import MapsImage from 'assets/image/manuva-maps.png'
import MapsImageTablet from 'assets/image/manuva-maps-tablet.png'
import MapsImageMobile from 'assets/image/manuva-maps-mobile.png'

const Maps = () => {
  const { sm, xl } = useResponsive()

  return (
    <section id="map" className=" m-auto left-0 right-0 bg-[#071126]">
      <img className="m-auto left-0 right-0" src={xl ? MapsImage : sm ? MapsImageTablet : MapsImageMobile} alt=""/>
    </section>
  )
}

export default Maps
